import { render, staticRenderFns } from "./DocumentsTableComponent.vue?vue&type=template&id=c62a8bd0&scoped=true&"
import script from "./DocumentsTableComponent.vue?vue&type=script&lang=js&"
export * from "./DocumentsTableComponent.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsTableComponent.vue?vue&type=style&index=0&id=c62a8bd0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62a8bd0",
  null
  
)

export default component.exports